import { render, staticRenderFns } from "./modalRequestMaterial.vue?vue&type=template&id=923e04a0&scoped=true"
import script from "./modalRequestMaterial.vue?vue&type=script&lang=js"
export * from "./modalRequestMaterial.vue?vue&type=script&lang=js"
import style0 from "./modalRequestMaterial.vue?vue&type=style&index=0&id=923e04a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e04a0",
  null
  
)

export default component.exports